import { trackEvent } from './trackEvent';

export const useTravelersSoguAnalytics = () => {
  const route = useRoute();
  const trackedPath = ref<string | null>(null);

  const trackPageview = () => {
    if (!route.path || trackedPath.value === route.path) {
      return;
    }

    trackedPath.value = route.path;
    void trackEvent('help-center-travelers.pageview', {});
  };

  const trackSupportButtonClick = () => {
    void trackEvent('help-center-travelers:send-question-button.click', {});
  };

  watch(
    () => route.path,
    () => {
      trackPageview();
    },
    { immediate: true },
  );

  return {
    trackSupportButtonClick,
  };
};
